const loggedMessages = new Set<string>();

export const errorOnce = (message: string): void => {
  if (loggedMessages.has(message)) {
    return;
  }
  loggedMessages.add(message);
  console.error(message);
};
